import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzCardModule } from '@blk/daisy/modules/cards';
import { SharedModule } from '@ddt-web/common';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { ExploreCardComponent } from './explore-card.component';

@NgModule({
	declarations: [ExploreCardComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		DzCardModule,
		DzIconModule.withIcons(faChevronRight),
		DzSelectModule,
		SharedModule
	],
	exports: [ExploreCardComponent]
})
export class ExploreCardModule { }
